// Generated by purs version 0.15.15
var Meet = /* #__PURE__ */ (function () {
    function Meet() {

    };
    Meet.value = new Meet();
    return Meet;
})();
var Slice = /* #__PURE__ */ (function () {
    function Slice() {

    };
    Slice.value = new Slice();
    return Slice;
})();
var showMeetOrSlice = {
    show: function (v) {
        if (v instanceof Meet) {
            return "Meet";
        };
        if (v instanceof Slice) {
            return "Slice";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.MeetOrSlice (line 15, column 10 - line 17, column 21): " + [ v.constructor.name ]);
    }
};
var printMeetOrSlice = function (v) {
    if (v instanceof Meet) {
        return "meet";
    };
    if (v instanceof Slice) {
        return "slice";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.MeetOrSlice (line 20, column 20 - line 22, column 19): " + [ v.constructor.name ]);
};
var eqMeetOrSlice = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Meet && y instanceof Meet) {
                return true;
            };
            if (x instanceof Slice && y instanceof Slice) {
                return true;
            };
            return false;
        };
    }
};
export {
    Meet,
    Slice,
    printMeetOrSlice,
    eqMeetOrSlice,
    showMeetOrSlice
};
